import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA-bPQAqAqj_2XR7jVphG1asgMeiqe9Kss",
  authDomain: "right-cash-eb558.firebaseapp.com",
  databaseURL: "https://right-cash-eb558-default-rtdb.firebaseio.com",
  projectId: "right-cash-eb558",
  storageBucket: "right-cash-eb558.firebasestorage.app",
  messagingSenderId: "517039116462",
  appId: "1:517039116462:web:5c386dab8f44af7dfcdd3f",
  measurementId: "G-L17K2FF9ZT",
};

// **Firebase Init**
const app = initializeApp(firebaseConfig);

// **Services**
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
